var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',{attrs:{"dense":""}},[_c('v-col',[_c('v-icon',{staticStyle:{"margin-bottom":"3px"},attrs:{"color":_vm.color,"small":""}},[_vm._v(" "+_vm._s(_vm.icon)+" ")])],1),_c('v-col',{staticStyle:{"padding-left":"0px","margin-top":"2px"}},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }